/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnInit } from '@angular/core';
import { AnalyticsService } from './@core/utils/analytics.service';
import {AuthService} from './shared/services/auth.service';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
  selector: 'lba-app',
  template: '<router-outlet (activate)="onActivate($event)" ></router-outlet>',
})
export class AppComponent implements OnInit {

  constructor(private analytics: AnalyticsService,
              private authService: AuthService,
              private router: Router) {
  }

  ngOnInit(): void {

    this.analytics.trackPageViews();
    // console.log('app component init : ', this.authService.isLoggedIn(), ' + ', this.authService.isAuthenticated)
    // if (this.authService.isLoggedIn()) {
    //   this.router.navigate(['/pages', 'sites']);
    // } else {
    //   this.router.navigate(['/login']);
    // }
  }

  onActivate(event) {
    window.scroll(0, 0);
    // or document.body.scrollTop = 0;
    // or document.querySelector('body').scrollTo(0,0)
  // ...
  }
}
